import React from "react";
import Footer from "../components/footer/Footer";
import SecondBanner from "../components/second-banner/SecondBanner";
import Navbar from "../components/navbar/Navbar";
import ProjectCard from "../components/projects-card/ProjectCard";

const Projects = () => {
  return (
    <>
      <Navbar />
      <SecondBanner
        head={"Projects"}
        text={"Some of my recent projects below"}
      />
      <ProjectCard />
      <Footer />
    </>
  );
};

export default Projects;
